module.exports = __webpack_public_path__ + "static/media/video-advmindfulness-observer-perspective-en.870b3421.vtt";